import { tokens, Typography, Stack } from '@cast/design-system';
import { formatCurrency } from '@cast/utils';

type ComputeCostCellProps = {
  monthlyTotal: number | null;
};

const formatClusterListMonthlyCost = (
  monthlyTotal: number | null | undefined
): string | null => {
  if (monthlyTotal == null) {
    return null;
  }

  return formatCurrency(monthlyTotal, {
    maximumFractionDigits: monthlyTotal < 1 ? 4 : 2,
  });
};

export const ComputeCostCell = ({ monthlyTotal }: ComputeCostCellProps) => {
  const text = formatClusterListMonthlyCost(monthlyTotal);

  if (!text) {
    return (
      <Typography
        variant="P12R"
        sx={{ color: tokens.theme.disabled.fg }}
        fontStyle="italic"
      >
        —
      </Typography>
    );
  }

  return (
    <Stack direction="row" gap={4} alignItems="baseline">
      <Typography
        variant="P12R"
        sx={{ color: tokens.theme.fg.structural.primary }}
        data-testid="money-val"
        noWrap
      >
        {text}
      </Typography>
      <Typography
        variant="P12R"
        sx={{ color: tokens.theme.fg.structural.secondary }}
        component="span"
      >
        /mo
      </Typography>
    </Stack>
  );
};
